import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const checkly = defineConnector({
  identifier: "checkly",
  name: "Checkly",
  tagLine: "Synthetic monitoring for APIs and apps",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.checklyhq\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.apiKey, scheme: "Bearer" },
      { name: "X-Checkly-Account", value: app.config.accountId },
    ]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Checkly](https://app.checklyhq.com/settings/user/api-keys), open **User Settings › API Keys** and create a key. Copy your account ID from **Account Settings › General**.",
        },
      ],
    },
    {
      title: "Enter your Checkly details",
      items: [
        {
          kind: "input",
          label: "Account ID",
          required: true,
          target: { kind: "configuration", field: "accountId" },
        },
        {
          kind: "input",
          label: "API key",
          placeholder: "cu_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.checklyhq.com/v1/checks?limit=1",
  },
});
